/**
 * Exact-match storefront search.
 *
 * Shopify's semantic (AI) search adds loosely related products to every
 * results page, so a search for "picopresso" returns the whole catalog.
 * Queries that use search syntax skip the semantic layer, so this script
 * wraps every word the shopper types in quotes before the search runs:
 *
 *   picopresso stand  ->  "picopresso" "stand"
 *
 * Each word is quoted on its own, so word order doesn't matter and every
 * word must match (plurals still match: "basket" finds "baskets").
 *
 * If an exact search finds nothing (a typo like "picapresso"), the search
 * page sends the shopper to the normal search instead, so they still see
 * the closest matches. That fallback lives in sections/main-search.liquid.
 *
 * Shoppers who type their own syntax (quotes, title:..., tag:..., OR,
 * wildcards, minus signs) are left alone.
 */
(function () {
  var SEARCH_PATH = /\/search\/?$/;

  function usesSearchSyntax(query) {
    return /[":*()]|(^|\s)-\S|\b(AND|OR|NOT)\b/.test(query);
  }

  function toExactQuery(query) {
    return query
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map(function (word) {
        return '"' + word + '"';
      })
      .join(' ');
  }

  document.addEventListener('submit', function (event) {
    // Another handler (e.g. predictive search opening a highlighted product) already took over.
    if (event.defaultPrevented) return;

    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var action;
    try {
      action = new URL(form.getAttribute('action') || '', window.location.href);
    } catch (e) {
      return;
    }
    if (action.origin !== window.location.origin || !SEARCH_PATH.test(action.pathname)) return;

    var data = new FormData(form);
    var query = String(data.get('q') || '').trim();
    if (!query || usesSearchSyntax(query)) return;

    event.preventDefault();

    var params = new URLSearchParams();
    data.forEach(function (value, key) {
      if (typeof value === 'string') params.append(key, value);
    });
    params.set('q', toExactQuery(query));

    window.location.assign(action.pathname + '?' + params.toString());
  });
})();
